export default __webpack_public_path__ + "static/media/DSC_7744.5fba42ff.jpg";